<template>
	<el-divider />
</template>

<script>
export default {
	name: 'DmsDivider',

};
</script>

<style lang="scss" scoped>

</style>
